import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from './../images/circle-info-regular-full.svg'

function ReviewByDate ({ localReviewByDateQuery, setLocalReviewByDateQuery }) {
  const today = new Date()
  const maxDate = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`

  const handleStartChange = e => {
    setLocalReviewByDateQuery({
      ...localReviewByDateQuery,
      start: e.target.value
    })
  }

  const handleEndChange = e => {
    setLocalReviewByDateQuery({
      ...localReviewByDateQuery,
      end: e.target.value
    })
  }

  return (
    <div className={styles.ReviewByDateContainer}>
      <h1 className={styles.ReviewByDateTitle}>Reviews by date</h1>

      <div className={styles.ReviewByDateFlexContainer}>
        {/* Start / Date added */}
        <div className={styles.ReviewByDateFlexColumn}>
          <div className={styles.ReviewByDateInlineLabel}>
            <span className={styles.ReviewByDateLabel}>Date added</span>
            <Tooltip
              title='Filters to reviews added on or after this date.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Date added help'
                width={14}
                height={14}
                className={styles.ReviewByDateInfoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            className={styles.ReviewByDateInput}
            type='date'
            name='start'
            max={maxDate}
            value={localReviewByDateQuery.start || ''}
            onChange={handleStartChange}
            required
          />
        </div>

        {/* End / Date updated */}
        <div className={styles.ReviewByDateFlexColumn}>
          <div className={styles.ReviewByDateInlineLabel}>
            <span className={styles.ReviewByDateLabel}>Date updated</span>
            <Tooltip
              title='Filters to reviews updated on or after this date.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Date updated help'
                width={14}
                height={14}
                className={styles.ReviewByDateInfoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            className={styles.ReviewByDateInput}
            type='date'
            name='end'
            max={maxDate}
            value={localReviewByDateQuery.end || ''}
            onChange={handleEndChange}
            required
          />
        </div>
      </div>
    </div>
  )
}

export default ReviewByDate
